import tmhRequest from '@/config/tmhRequest'


export default {
    searchListBank: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/bank/searchlistbank',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/bank.js